
export enum AppointmentStatusCd {
	APPOINTMENT_MISSING = 'AppointmentMissing',
	APPOINTMENT_PRESENT = 'AppointmentPresent',
	NO_APPOINTMENT = 'NoAppointment'}
